import {PerspectiveCamera} from 'three';
const clamp=(value,min,max)=>Math.max(min,Math.min(max,value));

export class PileCamera{
  constructor(){this.camera=new PerspectiveCamera(38,1,.02,60);this.yaw=0;this.pitch=.56;this.zoom=1;this.fit=8;this.update();}
  resize(width,height){this.camera.aspect=width/height;this.fit=Math.max(6.9,2.65/(Math.tan(19*Math.PI/180)*this.camera.aspect));this.update();}
  orbit(dx,dy){this.yaw-=dx*.008;this.pitch=clamp(this.pitch+dy*.006,.12,1.35);this.update();}
  magnify(factor){this.zoom=clamp(this.zoom*factor,.6,1.9);this.update();}
  reset(){this.yaw=0;this.pitch=.56;this.zoom=1;this.update();}
  update(){
    const distance=this.fit/this.zoom,flat=Math.cos(this.pitch)*distance;
    this.camera.position.set(-.35+Math.sin(this.yaw)*flat,.6+Math.sin(this.pitch)*distance,Math.cos(this.yaw)*flat);
    this.camera.lookAt(-.35,.6,0);this.camera.updateProjectionMatrix();this.camera.updateMatrixWorld();
  }
}
